import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=b168bd56&scoped=true&"
import script from "./SelfService.vue?vue&type=script&lang=js&"
export * from "./SelfService.vue?vue&type=script&lang=js&"
import style0 from "./SelfService.vue?vue&type=style&index=0&id=b168bd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b168bd56",
  null
  
)

export default component.exports